import { TypeOptions, UpdateOptions } from "react-toastify";

import { TInputTag } from "components/InputMultipleTag";
import { TSelectOption } from "components/Select";
import { MAP_TRANSLATION, TRANSLATION_KEY } from "./translation";

export enum LOCALSTORAGE_KEY {
  BUILD_VERSION = "BUILD_VERSION",
}

export type TWordBreakType = "normal" | "break-all" | "keep-all" | "break-word";

export type TAlignText = "left" | "right";

export type TCropPoint = {
  x: number;
  y: number;
  width?: number;
  height?: number;
};

export const AUTH_COOKIES_KEY = {
  TOKEN: "ATK",
  REFRESH_TOKEN: "RTK",
};

export const TOKEN_EXPIRED_MESSAGES = ["authorization token has expired"];
export const ERROR_NON_LOGOUT_MESSAGES = [
  "please use correct username/password",
  "permission denied",
];

export const MISSING_JAPANESE_TRANSLATION_MESSAGE =
  "(Missing Japanese Translation)";

export enum EENV {
  DEV = "development",
  QA = "qa",
  UAT = "uat",
  PROD = "production",
}

export enum EACOUNT_TYPE {
  SUPERADMIN = "super_admin",
  EMPLOYEE = "employee",
}

export const TOAST_CLOSE_TIME = 2000;

export const TOAST_DATA = (type: TypeOptions): UpdateOptions => ({
  type: type,
  autoClose: TOAST_CLOSE_TIME,
  isLoading: false,
  className: "toast-error",
});

export const LANGUAGE_MAP = {
  JA: "ja",
  EN: "en",
};

export const CALENDAR_VIEW = {
  MONTH: "month",
  YEAR: "year",
  DECADE: "decade",
};

export const GENDER = {
  FEMALE: "female",
  MALE: "male",
};

export const GENDER_LABEL = {
  [GENDER.FEMALE]: "female",
  [GENDER.MALE]: "male",
};

export const LANGUAGE_LABEL = {
  [LANGUAGE_MAP.JA]: "Japanese",
  [LANGUAGE_MAP.EN]: "English",
};

export const SUPPORTED_LANGUAGES = [
  {
    value: LANGUAGE_MAP.JA,
    label: LANGUAGE_LABEL[LANGUAGE_MAP.JA],
  },
  {
    value: LANGUAGE_MAP.EN,
    label: LANGUAGE_LABEL[LANGUAGE_MAP.EN],
  },
];

export const GENDERS = [
  {
    value: GENDER.MALE,
    label: GENDER_LABEL[GENDER.MALE],
  },
  {
    value: GENDER.FEMALE,
    label: GENDER_LABEL[GENDER.FEMALE],
  },
];

export const TERM_EMPLOYMENT_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FIXED],
    value: TRANSLATION_KEY.FIXED,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.INDEFINITE],
    value: TRANSLATION_KEY.INDEFINITE,
  },
];

export const COMMUTING_METHOD_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.CAR],
    value: TRANSLATION_KEY.CAR,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.BICYCLE],
    value: TRANSLATION_KEY.BICYCLE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.MOPED],
    value: TRANSLATION_KEY.MOPED,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.MOTORCYCLE],
    value: TRANSLATION_KEY.MOTORCYCLE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.WALKING],
    value: TRANSLATION_KEY.WALKING,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.PUBLIC_TRANSPORTATION],
    value: TRANSLATION_KEY.PUBLIC_TRANSPORTATION,
  },
];

export const MARTIAL_STATUS_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.MARRIED],
    value: TRANSLATION_KEY.MARRIED,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.UNMARRIED],
    value: TRANSLATION_KEY.UNMARRIED,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.DIVORCED],
    value: TRANSLATION_KEY.DIVORCED,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.WIDOWED],
    value: TRANSLATION_KEY.WIDOWED,
  },
];

export const POWER_OPTIONS: TSelectOption[] = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.POWER_0],
    value: `${Number(TRANSLATION_KEY.POWER_0)}`,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.POWER_0_5],
    value: `${Number(TRANSLATION_KEY.POWER_0_5)}`,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.POWER_0_75],
    value: `${Number(TRANSLATION_KEY.POWER_0_75)}`,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.POWER_1],
    value: `${Number(TRANSLATION_KEY.POWER_1)}`,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.POWER_1_25],
    value: `${Number(TRANSLATION_KEY.POWER_1_25)}`,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.POWER_1_5],
    value: `${Number(TRANSLATION_KEY.POWER_1_5)}`,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.POWER_1_75],
    value: `${Number(TRANSLATION_KEY.POWER_1_75)}`,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.POWER_2],
    value: `${Number(TRANSLATION_KEY.POWER_2)}`,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.POWER_2_25],
    value: `${Number(TRANSLATION_KEY.POWER_2_25)}`,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.POWER_2_5],
    value: `${Number(TRANSLATION_KEY.POWER_2_5)}`,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.POWER_2_75],
    value: `${Number(TRANSLATION_KEY.POWER_2_75)}`,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.POWER_3],
    value: `${Number(TRANSLATION_KEY.POWER_3)}`,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.POWER_3_25],
    value: `${Number(TRANSLATION_KEY.POWER_3_25)}`,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.POWER_3_5],
    value: `${Number(TRANSLATION_KEY.POWER_3_5)}`,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.POWER_3_75],
    value: `${Number(TRANSLATION_KEY.POWER_3_75)}`,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.POWER_4],
    value: `${Number(TRANSLATION_KEY.POWER_4)}`,
  },
];

export const PREFERRED_WORKING_SCHEDULE_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.DAY_SHIFT],
    value: TRANSLATION_KEY.DAY_SHIFT,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.NIGHT_SHIFT],
    value: TRANSLATION_KEY.NIGHT_SHIFT,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.ROTATIONAL_SHIFT_INCLUDING_MIDNIGHT],
    value: TRANSLATION_KEY.ROTATIONAL_SHIFT_INCLUDING_MIDNIGHT,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.ROTATIONAL_SHIFT_EXCLUDING_MIDNIGHT],
    value: TRANSLATION_KEY.ROTATIONAL_SHIFT_EXCLUDING_MIDNIGHT,
  },
];

export const WORKING_HOURS_TYPE_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.DAY_SHIFT],
    value: TRANSLATION_KEY.DAY_SHIFT,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.NIGHT_SHIFT],
    value: TRANSLATION_KEY.NIGHT_SHIFT,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.ROTATIONAL_SHIFT],
    value: TRANSLATION_KEY.ROTATIONAL_SHIFT,
  },
];

export const WORKING_TIME_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.HOUR],
    value: TRANSLATION_KEY.HOUR,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.MONTH],
    value: TRANSLATION_KEY.MONTH,
  },
];

export const WAGE_TIME_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.HOUR],
    value: TRANSLATION_KEY.HOUR,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.WEEK],
    value: TRANSLATION_KEY.WEEK,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.MONTH],
    value: TRANSLATION_KEY.MONTH,
  },
];

export const BREAK_TIME_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.MINUTES],
    value: TRANSLATION_KEY.MINUTES,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.HOUR],
    value: TRANSLATION_KEY.HOUR,
  },
];

export const PREFERRED_EMPLOYMENT_DURATION_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.LONG_TERM],
    value: TRANSLATION_KEY.LONG_TERM,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.SHORT_TERM],
    value: TRANSLATION_KEY.SHORT_TERM,
  },
];

export const EMPLOYEMENT_INSURANCE_STATUS_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.RENEWAL],
    value: TRANSLATION_KEY.RENEWAL,
  },
];

export const REASON_NOT_JOINING_INSURANCE_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.MONTHLY_INCOME_OF_88000_YEN_OR_LESS],
    value: TRANSLATION_KEY.MONTHLY_INCOME_OF_88000_YEN_OR_LESS,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.BEING_A_STUDENT],
    value: TRANSLATION_KEY.BEING_A_STUDENT,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.WORKING_WITHIN_20_HOURS_PER_WEEK],
    value: TRANSLATION_KEY.WORKING_WITHIN_20_HOURS_PER_WEEK,
  },
];

export const GRADE_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.REQUIRING_SUPPORT_1],
    value: TRANSLATION_KEY.REQUIRING_SUPPORT_1,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.REQUIRING_SUPPORT_2],
    value: TRANSLATION_KEY.REQUIRING_SUPPORT_2,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.REQUIRING_LONG_TERM_CARE_1],
    value: TRANSLATION_KEY.REQUIRING_LONG_TERM_CARE_1,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.REQUIRING_LONG_TERM_CARE_2],
    value: TRANSLATION_KEY.REQUIRING_LONG_TERM_CARE_2,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.REQUIRING_LONG_TERM_CARE_3],
    value: TRANSLATION_KEY.REQUIRING_LONG_TERM_CARE_3,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.REQUIRING_LONG_TERM_CARE_4],
    value: TRANSLATION_KEY.REQUIRING_LONG_TERM_CARE_4,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.REQUIRING_LONG_TERM_CARE_5],
    value: TRANSLATION_KEY.REQUIRING_LONG_TERM_CARE_5,
  },
];

export const DAYS_OF_WEEK = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

export const HOLIDAY_OFF = "holiday_off";

export const INITIAL_DAYS = [...DAYS_OF_WEEK, HOLIDAY_OFF];

export const DEFAULT_VALUE = {
  COUNTRY: "Japan",
  ISD_CODE: "+81", //Japan
  WORKING_TIME: "Month",
  BREAK_TIME: "Hour",
  WAGE: "Hour",
  LOCALE: "en-US",
  LANGUAGE: "ja", //Japanese,
  METRIK: "cm",
  DISTANCE: "m",
  WEIGHT: "kg",
  CURRENCY: "Yen",
  DATE_FORMAT: "yyyy/MM/dd",
  DATE_MONTH_FORMAT: "yyyy/MM",
  DATE_TIME_FORMAT_WITHOUT_SECONDS: "yyyy/MM/dd HH:mm",
};

export const JAPANESE_DATE_DISPLAY_FORMAT = "yyyy年MM月dd日";

export const DAY_ORDER: Record<string, number> = {
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
  sunday: 7,
  [HOLIDAY_OFF]: 8,
};

export const MAP_LOCALE: Record<string, string> = {
  "en-GB": DEFAULT_VALUE.LOCALE,
};

export const EMPLOYEE_POST_MAP_TRANSLATION: Record<string, string> = {
  Operator: "operator",
  "Customer Success": "customer_success",
  Sales: "sales",
  "Branch Manager": "branch_manager",
};

export const MAIN_LAYOUT_ID = "main-layout";

export const PIPELINE = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.NEW_DEVELOPEMENT],
    value: TRANSLATION_KEY.NEW_DEVELOPEMENT,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.UPSELL],
    value: TRANSLATION_KEY.UPSELL,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.CROSS_SELL],
    value: TRANSLATION_KEY.CROSS_SELL,
  },
];

export const PIPELINE_STATUS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.INCREASE_STAFF],
    value: TRANSLATION_KEY.INCREASE_STAFF,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.NEGOTIATING],
    value: TRANSLATION_KEY.NEGOTIATING,
  },
];

export const CORPORATION_TYPE = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.CORPORATION],
    value: TRANSLATION_KEY.CORPORATION,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.LIMITED_COMPANY],
    value: TRANSLATION_KEY.LIMITED_COMPANY,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.GENERAL_PARTNERSHIP],
    value: TRANSLATION_KEY.GENERAL_PARTNERSHIP,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.LIMITED_PARTNERSHIP],
    value: TRANSLATION_KEY.LIMITED_PARTNERSHIP,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.LLC],
    value: TRANSLATION_KEY.LLC,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FOREIGN_COMPANY],
    value: TRANSLATION_KEY.FOREIGN_COMPANY,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.NATIONAL_GOVERNMENT_AGENCY],
    value: TRANSLATION_KEY.NATIONAL_GOVERNMENT_AGENCY,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.LOCAL_PUBLIC_ENTITY],
    value: TRANSLATION_KEY.LOCAL_PUBLIC_ENTITY,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.OTHER_INCORPORATED_ENTITY],
    value: TRANSLATION_KEY.OTHER_INCORPORATED_ENTITY,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.OTHER],
    value: TRANSLATION_KEY.OTHER,
  },
];

export const WORKFORCE_MANAGEMENT_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.LABOR_MANAGEMENT_AGREEMENT_METHOD],
    value: TRANSLATION_KEY.LABOR_MANAGEMENT_AGREEMENT_METHOD,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.EQUAL_BALANCED_TREATMENT_METHOD],
    value: TRANSLATION_KEY.EQUAL_BALANCED_TREATMENT_METHOD,
  },
];

export const INVOICE_BEGIN_DATE_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FORTY_HOURS_PER_WEEK],
    value: TRANSLATION_KEY.FORTY_HOURS_PER_WEEK,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.SIX_DAYS],
    value: TRANSLATION_KEY.SIX_DAYS,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.SEVEN_DAYS],
    value: TRANSLATION_KEY.SEVEN_DAYS,
  },
];

export enum ENTITY_TYPE {
  CLIENT = "client",
  STAFF = "staff",
}

export const LATE_NIGHT_CALCULATION_METHOD_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.ALLOWANCE],
    value: TRANSLATION_KEY.ALLOWANCE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.UNIT_RATE],
    value: TRANSLATION_KEY.UNIT_RATE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.OTHER_NEW.toLowerCase()],
    value: TRANSLATION_KEY.OTHER_NEW.toLowerCase(),
  },
];

export const CONSUMPTION_TAX_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.ROUNDING],
    value: TRANSLATION_KEY.ROUNDING,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.ROUNDING_DOWN],
    value: TRANSLATION_KEY.ROUNDING_DOWN,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.ROUNDING_UP],
    value: TRANSLATION_KEY.ROUNDING_UP,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.OTHER_NEW.toLowerCase()],
    value: TRANSLATION_KEY.OTHER_NEW.toLowerCase(),
  },
];

export const EMPLOYMENT_TYPE_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.PERMANENT],
    value: TRANSLATION_KEY.PERMANENT,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FEE_CHARGING_EMPLOYMENT_PLACEMENT],
    value: TRANSLATION_KEY.FEE_CHARGING_EMPLOYMENT_PLACEMENT,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.SHORT_TERM],
    value: TRANSLATION_KEY.SHORT_TERM,
  },
];

export const METRIK_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.CM],
    value: TRANSLATION_KEY.CM,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.M],
    value: TRANSLATION_KEY.M,
  },
];

export const WEIGHT_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.G],
    value: TRANSLATION_KEY.G,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.KG],
    value: TRANSLATION_KEY.KG,
  },
];

export const SMOKING_ENVIRONMENT_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.NO_SMOKING_ON_PERMISES],
    value: TRANSLATION_KEY.NO_SMOKING_ON_PERMISES,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.INDOOR_SEPARATE_SMOKE_AREA],
    value: TRANSLATION_KEY.INDOOR_SEPARATE_SMOKE_AREA,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.OUTDOOR_SEPARATE_SMOKE_AREA],
    value: TRANSLATION_KEY.OUTDOOR_SEPARATE_SMOKE_AREA,
  },
];

export const CURRENCY_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.YEN],
    value: TRANSLATION_KEY.YEN,
  },
];

export const UNIFORM_LOAN_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FREE],
    value: TRANSLATION_KEY.FREE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.LOAN],
    value: TRANSLATION_KEY.LOAN,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.OWN],
    value: TRANSLATION_KEY.OWN,
  },
];

export const ALLOWANCE_TYPE_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.TRANSPORTATION],
    value: TRANSLATION_KEY.TRANSPORTATION,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.MEAL],
    value: TRANSLATION_KEY.MEAL,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.HOUSING],
    value: TRANSLATION_KEY.HOUSING,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.HEALTH_CHECKUP],
    value: TRANSLATION_KEY.HEALTH_CHECKUP,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.TRAVEL],
    value: TRANSLATION_KEY.TRAVEL,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.SELF_DEVELOPMENT],
    value: TRANSLATION_KEY.SELF_DEVELOPMENT,
  },
];

export const FREQUENCY_WORKING_HOLIDAYS_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.CORPORATE_CALENDAR],
    value: TRANSLATION_KEY.CORPORATE_CALENDAR,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.DAY_OF_WEEK],
    value: TRANSLATION_KEY.DAY_OF_WEEK,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.ROTATION],
    value: TRANSLATION_KEY.ROTATION,
  },
];

export const MONTH_DAYS_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.LAST_DAY_OF_MONTH],
    value: TRANSLATION_KEY.LAST_DAY_OF_MONTH,
  },
  ...[...Array(31)].map((_, index) => ({
    label: `${index + 1}`,
    value: `${index + 1}`,
  })),
];

export const PARTIAL_MONTH_DAYS_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.LAST_DAY_OF_MONTH],
    value: TRANSLATION_KEY.LAST_DAY_OF_MONTH,
  },
  ...["5", "10", "15", "20", "25"].map((day) => ({
    label: day,
    value: day,
  })),
];

export const TAG_TYPE_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.TAG_STAFF],
    value: TRANSLATION_KEY.TAG_STAFF,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.TAG_CORPORATION],
    value: TRANSLATION_KEY.TAG_CORPORATION,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.TAG_JOB_LISTING],
    value: TRANSLATION_KEY.TAG_JOB_LISTING,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.TAG_TICKET],
    value: TRANSLATION_KEY.TAG_TICKET,
  },
];

export const RELATIONSHIP_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.RELATIONSHIP_FATHER],
    value: TRANSLATION_KEY.RELATIONSHIP_FATHER,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.RELATIONSHIP_MOTHER],
    value: TRANSLATION_KEY.RELATIONSHIP_MOTHER,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.RELATIONSHIP_GRANDFATHER],
    value: TRANSLATION_KEY.RELATIONSHIP_GRANDFATHER,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.RELATIONSHIP_GRANDMOTHER],
    value: TRANSLATION_KEY.RELATIONSHIP_GRANDMOTHER,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.RELATIONSHIP_CHILD],
    value: TRANSLATION_KEY.RELATIONSHIP_CHILD,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.RELATIONSHIP_GRANDCHILD],
    value: TRANSLATION_KEY.RELATIONSHIP_GRANDCHILD,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.RELATIONSHIP_FRIEND],
    value: TRANSLATION_KEY.RELATIONSHIP_FRIEND,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.OTHER],
    value: TRANSLATION_KEY.OTHER,
  },
];

export const POSIBILITY_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.POSSIBILITY_POSSIBLE],
    value: TRANSLATION_KEY.POSSIBILITY_POSSIBLE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.POSSIBILITY_NOT_POSSIBLE],
    value: TRANSLATION_KEY.POSSIBILITY_NOT_POSSIBLE,
  },
];

export const API_DATE_FORMAT = "yyyy-MM-dd";

export const DATE_TIME_FORMAT = "yyyy-MM-dd HH:mm:ss";

// 1000000KB = 1MB
export const KB_MB_SIZE = 1000000;

export const REJECT_JOB_TYPES_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.REJECT_JOB_TYPES_FOOD_MANUFACTURING],
    value: TRANSLATION_KEY.REJECT_JOB_TYPES_FOOD_MANUFACTURING,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.REJECT_JOB_TYPES_CLEAN_ROOM],
    value: TRANSLATION_KEY.REJECT_JOB_TYPES_CLEAN_ROOM,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.REJECT_JOB_TYPES_ASSEMBLY_LINE_WORK],
    value: TRANSLATION_KEY.REJECT_JOB_TYPES_ASSEMBLY_LINE_WORK,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.REJECT_JOB_TYPES_HEAVY_LIFTING],
    value: TRANSLATION_KEY.REJECT_JOB_TYPES_HEAVY_LIFTING,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.REJECT_JOB_TYPES_STANDING_WORK],
    value: TRANSLATION_KEY.REJECT_JOB_TYPES_STANDING_WORK,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.REJECT_JOB_TYPES_STATIONARY_WORK],
    value: TRANSLATION_KEY.REJECT_JOB_TYPES_STATIONARY_WORK,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.REJECT_JOB_TYPES_WORK_REQUIRING_GOOD_EYESIGHT
      ],
    value: TRANSLATION_KEY.REJECT_JOB_TYPES_WORK_REQUIRING_GOOD_EYESIGHT,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.REJECT_JOB_TYPES_HOT_ENVIRONMENT],
    value: TRANSLATION_KEY.REJECT_JOB_TYPES_HOT_ENVIRONMENT,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.REJECT_JOB_TYPES_COLD_ENVIRONMENT],
    value: TRANSLATION_KEY.REJECT_JOB_TYPES_COLD_ENVIRONMENT,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.REJECT_JOB_TYPES_CUSTOMER_SERVICE],
    value: TRANSLATION_KEY.REJECT_JOB_TYPES_CUSTOMER_SERVICE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.REJECT_JOB_TYPES_CLERICAL_WORK],
    value: TRANSLATION_KEY.REJECT_JOB_TYPES_CLERICAL_WORK,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.REJECT_JOB_TYPES_NURSING_CARE],
    value: TRANSLATION_KEY.REJECT_JOB_TYPES_NURSING_CARE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.REJECT_JOB_TYPES_MANUFACTURING],
    value: TRANSLATION_KEY.REJECT_JOB_TYPES_MANUFACTURING,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.REJECT_JOB_TYPES_LOGISTICS],
    value: TRANSLATION_KEY.REJECT_JOB_TYPES_LOGISTICS,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.REJECT_JOB_TYPES_SALES],
    value: TRANSLATION_KEY.REJECT_JOB_TYPES_SALES,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.OTHER_NEW],
    value: TRANSLATION_KEY.OTHER_NEW,
  },
];

export const DESIRED_JOB_TYPES_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.DESIRED_JOB_TYPES_CUSTOMER_SERVICE],
    value: TRANSLATION_KEY.DESIRED_JOB_TYPES_CUSTOMER_SERVICE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.DESIRED_JOB_TYPES_CLERICAL_WORK],
    value: TRANSLATION_KEY.DESIRED_JOB_TYPES_CLERICAL_WORK,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.DESIRED_JOB_TYPES_NURSING_CARE],
    value: TRANSLATION_KEY.DESIRED_JOB_TYPES_NURSING_CARE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.DESIRED_JOB_TYPES_COOKING],
    value: TRANSLATION_KEY.DESIRED_JOB_TYPES_COOKING,
  },
  {
    label:
      MAP_TRANSLATION[TRANSLATION_KEY.DESIRED_JOB_TYPES_FORKLIFT_OPERATION],
    value: TRANSLATION_KEY.DESIRED_JOB_TYPES_FORKLIFT_OPERATION,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.DESIRED_JOB_TYPES_PICKING],
    value: TRANSLATION_KEY.DESIRED_JOB_TYPES_PICKING,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.DESIRED_JOB_TYPES_DELIVERY],
    value: TRANSLATION_KEY.DESIRED_JOB_TYPES_DELIVERY,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.DESIRED_JOB_TYPES_MANUFACTURING],
    value: TRANSLATION_KEY.DESIRED_JOB_TYPES_MANUFACTURING,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.DESIRED_JOB_TYPES_LOGISTICS],
    value: TRANSLATION_KEY.DESIRED_JOB_TYPES_LOGISTICS,
  },
  {
    label:
      MAP_TRANSLATION[TRANSLATION_KEY.DESIRED_JOB_TYPES_FOOD_MANUFACTURING],
    value: TRANSLATION_KEY.DESIRED_JOB_TYPES_FOOD_MANUFACTURING,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.DESIRED_JOB_TYPES_SITTING_WORK],
    value: TRANSLATION_KEY.DESIRED_JOB_TYPES_SITTING_WORK,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.OTHER_NEW],
    value: TRANSLATION_KEY.OTHER_NEW,
  },
];

export const PHYSICAL_CHARACTERISTICS_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.PHYSICAL_CHARACTERISTICS_DYED_HAIR],
    value: TRANSLATION_KEY.PHYSICAL_CHARACTERISTICS_DYED_HAIR,
  },
  {
    label:
      MAP_TRANSLATION[TRANSLATION_KEY.PHYSICAL_CHARACTERISTICS_SHAVED_HEAD],
    value: TRANSLATION_KEY.PHYSICAL_CHARACTERISTICS_SHAVED_HEAD,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.PHYSICAL_CHARACTERISTICS_BEARD],
    value: TRANSLATION_KEY.PHYSICAL_CHARACTERISTICS_BEARD,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.PHYSICAL_CHARACTERISTICS_NAIL_ART],
    value: TRANSLATION_KEY.PHYSICAL_CHARACTERISTICS_NAIL_ART,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.PHYSICAL_CHARACTERISTICS_NON_REMOVABLE_PIERCINGS
      ],
    value: TRANSLATION_KEY.PHYSICAL_CHARACTERISTICS_NON_REMOVABLE_PIERCINGS,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.PHYSICAL_CHARACTERISTICS_TATTOOS],
    value: TRANSLATION_KEY.PHYSICAL_CHARACTERISTICS_TATTOOS,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.PHYSICAL_CHARACTERISTICS_SIZE_3L_OR_ABOVE
      ],
    value: TRANSLATION_KEY.PHYSICAL_CHARACTERISTICS_SIZE_3L_OR_ABOVE,
  },
];

export const JAPANESE_LANGUAGE_LEVEL_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.JAPANESE_LANGUAGE_LEVEL_HIRAGANA],
    value: TRANSLATION_KEY.JAPANESE_LANGUAGE_LEVEL_HIRAGANA,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.JAPANESE_LANGUAGE_LEVEL_KANJI],
    value: TRANSLATION_KEY.JAPANESE_LANGUAGE_LEVEL_KANJI,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.JAPANESE_LANGUAGE_LEVEL_KATAKANA],
    value: TRANSLATION_KEY.JAPANESE_LANGUAGE_LEVEL_KATAKANA,
  },
];

export const HEALTH_CONDITION_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.HEALTH_CONDITION_NORMAL],
    value: TRANSLATION_KEY.HEALTH_CONDITION_NORMAL,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.HEALTH_CONDITION_HAS_CONDITION],
    value: TRANSLATION_KEY.HEALTH_CONDITION_HAS_CONDITION,
  },
];

export const STAFF_QUALIFICATION_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.QUALIFITAION_DRIVERS_LICENSE],
    value: TRANSLATION_KEY.QUALIFITAION_DRIVERS_LICENSE,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.QUALIFITAION_LARGE_VEHICLE_DRIVERS_LICENSE
      ],
    value: TRANSLATION_KEY.QUALIFITAION_LARGE_VEHICLE_DRIVERS_LICENSE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.QUALIFITAION_FORKLIFT_CERTIFICATION],
    value: TRANSLATION_KEY.QUALIFITAION_FORKLIFT_CERTIFICATION,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.QUALIFITAION_SLINGING_CERTIFICATION],
    value: TRANSLATION_KEY.QUALIFITAION_SLINGING_CERTIFICATION,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.QUALIFITAION_CRANE_CERTIFICATION],
    value: TRANSLATION_KEY.QUALIFITAION_CRANE_CERTIFICATION,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.QUALIFITAION_BOOKEEPING_LEVEL_3],
    value: TRANSLATION_KEY.QUALIFITAION_BOOKEEPING_LEVEL_3,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.QUALIFITAION_BOOKEEPING_LEVEL_2],
    value: TRANSLATION_KEY.QUALIFITAION_BOOKEEPING_LEVEL_2,
  },
  {
    label:
      MAP_TRANSLATION[TRANSLATION_KEY.QUALIFITAION_NURSERY_TEACHER_LICENSE],
    value: TRANSLATION_KEY.QUALIFITAION_NURSERY_TEACHER_LICENSE,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.QUALIFITAION_KINDERGARTEN_TEACHER_LICENSE
      ],
    value: TRANSLATION_KEY.QUALIFITAION_KINDERGARTEN_TEACHER_LICENSE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.QUALIFITAION_COOK_LICENSE],
    value: TRANSLATION_KEY.QUALIFITAION_COOK_LICENSE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.QUALIFITAION_NUTRITIONIST_LICENSE],
    value: TRANSLATION_KEY.QUALIFITAION_NUTRITIONIST_LICENSE,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.QUALIFITAION_CERTIFIED_CARE_WORKER_BEGINNER_TRAINING
      ],
    value: TRANSLATION_KEY.QUALIFITAION_CERTIFIED_CARE_WORKER_BEGINNER_TRAINING,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.OTHER_NEW],
    value: TRANSLATION_KEY.OTHER_NEW,
  },
];

export const STAFF_EMPLOYMENT_TYPE_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.EMPLOYMENT_TYPE_PERMANENT_EMPLOYEE],
    value: TRANSLATION_KEY.EMPLOYMENT_TYPE_PERMANENT_EMPLOYEE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.EMPLOYMENT_TYPE_CONTRACT_EMPLOYEE],
    value: TRANSLATION_KEY.EMPLOYMENT_TYPE_CONTRACT_EMPLOYEE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.EMPLOYMENT_TYPE_PART_TIME],
    value: TRANSLATION_KEY.EMPLOYMENT_TYPE_PART_TIME,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.EMPLOYMENT_TYPE_PART_TIME_ARBEIT],
    value: TRANSLATION_KEY.EMPLOYMENT_TYPE_PART_TIME_ARBEIT,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.EMPLOYMENT_TYPE_DISPATCH],
    value: TRANSLATION_KEY.EMPLOYMENT_TYPE_DISPATCH,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.EMPLOYMENT_TYPE_OUTSOURCE],
    value: TRANSLATION_KEY.EMPLOYMENT_TYPE_OUTSOURCE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.EMPLOYMENT_TYPE_SELF_EMPLOYED],
    value: TRANSLATION_KEY.EMPLOYMENT_TYPE_SELF_EMPLOYED,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.OTHER_NEW],
    value: TRANSLATION_KEY.OTHER_NEW,
  },
];

export const RESIGNATION_REASON_TYPE_OPTIONS = [
  {
    label:
      MAP_TRANSLATION[TRANSLATION_KEY.RESIGNATION_REASON_CONTRACT_COMPLETION],
    value: TRANSLATION_KEY.RESIGNATION_REASON_CONTRACT_COMPLETION,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.RESIGNATION_REASON_PERSONAL_REASON],
    value: TRANSLATION_KEY.RESIGNATION_REASON_PERSONAL_REASON,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.RESIGNATION_REASON_POOR_HEALTH],
    value: TRANSLATION_KEY.RESIGNATION_REASON_POOR_HEALTH,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.RESIGNATION_REASON_CAREGIVING],
    value: TRANSLATION_KEY.RESIGNATION_REASON_CAREGIVING,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.RESIGNATION_REASON_MOVING],
    value: TRANSLATION_KEY.RESIGNATION_REASON_MOVING,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.RESIGNATION_REASON_MARRIAGE],
    value: TRANSLATION_KEY.RESIGNATION_REASON_MARRIAGE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.RESIGNATION_REASON_CHILDBIRTH],
    value: TRANSLATION_KEY.RESIGNATION_REASON_CHILDBIRTH,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.RESIGNATION_REASON_CAREER_UP],
    value: TRANSLATION_KEY.RESIGNATION_REASON_CAREER_UP,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.OTHER_NEW],
    value: TRANSLATION_KEY.OTHER_NEW,
  },
];

export const TYPE_OF_WORK_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.TYPE_OF_WORK_ONSITE],
    value: TRANSLATION_KEY.TYPE_OF_WORK_ONSITE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.TYPE_OF_WORK_REMOTE],
    value: TRANSLATION_KEY.TYPE_OF_WORK_REMOTE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.TYPE_OF_WORK_HYBRID],
    value: TRANSLATION_KEY.TYPE_OF_WORK_HYBRID,
  },
];

export const DESIRED_DURATION_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.LONG_TERM],
    value: TRANSLATION_KEY.LONG_TERM,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.SHORT_TERM],
    value: TRANSLATION_KEY.SHORT_TERM,
  },
];

export const FIELD_STUDY_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FIELD_STUDY_INDUSTRIAL],
    value: TRANSLATION_KEY.FIELD_STUDY_INDUSTRIAL,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FIELD_STUDY_COMMERCE],
    value: TRANSLATION_KEY.FIELD_STUDY_COMMERCE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.OTHER_NEW],
    value: TRANSLATION_KEY.OTHER_NEW,
  },
];

export const ENROLLED_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.ENROLLED],
    value: TRANSLATION_KEY.ENROLLED,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.NOT_ENROLLED],
    value: TRANSLATION_KEY.NOT_ENROLLED,
  },
];

export const NOT_ENROLLED_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.LESS_THAN_20_HOURS_PER_WEEK],
    value: TRANSLATION_KEY.LESS_THAN_20_HOURS_PER_WEEK,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.EXPECTED_LESS_THAN_31_DAYS],
    value: TRANSLATION_KEY.EXPECTED_LESS_THAN_31_DAYS,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.ENROLLED_IN_OTHERS],
    value: TRANSLATION_KEY.ENROLLED_IN_OTHERS,
  },
];

export const NOT_SOCIAL_INSURANCE_ENROLLED_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.LESS_THAN_20_HOURS_PER_WEEK],
    value: TRANSLATION_KEY.LESS_THAN_20_HOURS_PER_WEEK,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.LESS_THAN_30_HOURS_PER_WEEK],
    value: TRANSLATION_KEY.LESS_THAN_30_HOURS_PER_WEEK,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.MONTHLY_SALARY_UNDER_80K_YEN],
    value: TRANSLATION_KEY.MONTHLY_SALARY_UNDER_80K_YEN,
  },
  {
    label:
      MAP_TRANSLATION[TRANSLATION_KEY.EXPECTED_EMPLOYMENT_LESS_THAN_2MONTH],
    value: TRANSLATION_KEY.EXPECTED_EMPLOYMENT_LESS_THAN_2MONTH,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.STUDENT],
    value: TRANSLATION_KEY.STUDENT,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.YEARS_70_OR_OLDER],
    value: TRANSLATION_KEY.YEARS_70_OR_OLDER,
  },
];

export const ENROLLED_IN_OTHER_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.ENROLLED_IN_OTHERS_DOUBLE_WORK],
    value: TRANSLATION_KEY.ENROLLED_IN_OTHERS_DOUBLE_WORK,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.ENROLLED_IN_OTHERS_PAID_LEAVE_PREVIOUS_EMPLOYMENT
      ],
    value: TRANSLATION_KEY.ENROLLED_IN_OTHERS_PAID_LEAVE_PREVIOUS_EMPLOYMENT,
  },
];

export const SOCIAL_INSURANCE_TYPE_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.SOCIAL_INSURANCE_WELFARE_PENSION],
    value: TRANSLATION_KEY.SOCIAL_INSURANCE_WELFARE_PENSION,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.SOCIAL_INSURANCE_HEALTH_INSURANCE],
    value: TRANSLATION_KEY.SOCIAL_INSURANCE_HEALTH_INSURANCE,
  },
];

export const WELFARE_PENSION_STATUS_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.ENROLLED],
    value: TRANSLATION_KEY.ENROLLED,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.YEARS_70_OR_OLDER_LOSS],
    value: TRANSLATION_KEY.YEARS_70_OR_OLDER_LOSS,
  },
];

export const HEALTH_INSURANCE_DETAIL_OPTIONS = [
  {
    label:
      MAP_TRANSLATION[TRANSLATION_KEY.YEARS_40_OR_OLDER_HAS_NURSING_INSURANCE],
    value: TRANSLATION_KEY.YEARS_40_OR_OLDER_HAS_NURSING_INSURANCE,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.LESS_THAN_40_YEARS_OLD_NO_NURSING_INSURANCE
      ],
    value: TRANSLATION_KEY.LESS_THAN_40_YEARS_OLD_NO_NURSING_INSURANCE,
  },
];

export const DEFAULT_DATE_FORMAT = "yyyy/MM/dd";

export const PERSONAL_IDENTIFICATIONL_OPTIONS = [
  {
    label:
      MAP_TRANSLATION[TRANSLATION_KEY.PERSONAL_IDENTIFICATION_DRIVERS_LICENCE],
    value: TRANSLATION_KEY.PERSONAL_IDENTIFICATION_DRIVERS_LICENCE,
  },
  {
    label:
      MAP_TRANSLATION[TRANSLATION_KEY.PERSONAL_IDENTIFICATION_MY_NUMBER_CARD],
    value: TRANSLATION_KEY.PERSONAL_IDENTIFICATION_MY_NUMBER_CARD,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.PERSONAL_IDENTIFICATION_PASSPORT],
    value: TRANSLATION_KEY.PERSONAL_IDENTIFICATION_PASSPORT,
  },
  {
    label:
      MAP_TRANSLATION[TRANSLATION_KEY.PERSONAL_IDENTIFICATION_RESIDENCE_CARD],
    value: TRANSLATION_KEY.PERSONAL_IDENTIFICATION_RESIDENCE_CARD,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY
          .PERSONAL_IDENTIFICATION_BASIC_RESIDENCE_REGISTRATION_CARD
      ],
    value:
      TRANSLATION_KEY.PERSONAL_IDENTIFICATION_BASIC_RESIDENCE_REGISTRATION_CARD,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.PERSONAL_IDENTIFICATION_STUDENT_ID],
    value: TRANSLATION_KEY.PERSONAL_IDENTIFICATION_STUDENT_ID,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.OTHER_NEW],
    value: TRANSLATION_KEY.OTHER_NEW,
  },
];

export const RESIDENCE_CARD_TYPE_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.RESIDENCE_CARD_PERMANENT_RESIDENT],
    value: TRANSLATION_KEY.RESIDENCE_CARD_PERMANENT_RESIDENT,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.RESIDENCE_CARD_LONG_TERM_RESIDENT],
    value: TRANSLATION_KEY.RESIDENCE_CARD_LONG_TERM_RESIDENT,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.RESIDENCE_CARD_SPOUSE_OF_JAPANESE_NATIONAL
      ],
    value: TRANSLATION_KEY.RESIDENCE_CARD_SPOUSE_OF_JAPANESE_NATIONAL,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.RESIDENCE_CARD_SPOUSE_OF_PERMANENT_RESIDENT
      ],
    value: TRANSLATION_KEY.RESIDENCE_CARD_SPOUSE_OF_PERMANENT_RESIDENT,
  },
];

export const MONTH_ADJUSTMENT_RULE_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.NEXT_MONTH],
    value: TRANSLATION_KEY.NEXT_MONTH,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.THIS_MONTH],
    value: TRANSLATION_KEY.THIS_MONTH,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.NEXT_BUSINESS_DAY],
    value: TRANSLATION_KEY.NEXT_BUSINESS_DAY,
  },
];

export const SHIFT_DATE_BY_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.PREVIOUS_DAY],
    value: TRANSLATION_KEY.PREVIOUS_DAY,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.NEXT_DAY],
    value: TRANSLATION_KEY.NEXT_DAY,
  },
];

export const DELIVERY_METHOD_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.MAIL],
    value: TRANSLATION_KEY.MAIL,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FAX],
    value: TRANSLATION_KEY.FAX,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.BRANCH_MAMAGER_MAIL],
    value: TRANSLATION_KEY.BRANCH_MAMAGER_MAIL,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.UNNECESSARY],
    value: TRANSLATION_KEY.UNNECESSARY,
  },
];

export const INVOICE_CLOSING_DATE_TYPE_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.UNNECESSARY],
    value: TRANSLATION_KEY.UNNECESSARY,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.POSTAL_MAIL],
    value: TRANSLATION_KEY.POSTAL_MAIL,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.WEB_SETTLEMENT],
    value: TRANSLATION_KEY.WEB_SETTLEMENT,
  },
];

export const ORIGINAL_INVOICE_CLOSING_DATE_TYPE_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.NEXT_MONTH],
    value: TRANSLATION_KEY.NEXT_MONTH,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.THIS_MONTH],
    value: TRANSLATION_KEY.THIS_MONTH,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.NEXT_BUSINESS_DAY],
    value: TRANSLATION_KEY.NEXT_BUSINESS_DAY,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.AFTER_SENDING],
    value: TRANSLATION_KEY.AFTER_SENDING,
  },
];

export const CALCULATION_METHOD_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.SEXAGESIMAL],
    value: TRANSLATION_KEY.SEXAGESIMAL,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.DECIMAL],
    value: TRANSLATION_KEY.DECIMAL,
  },
];

export const ONLINE_PAYMENT_PLATFORM_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.ESTAFFING],
    value: TRANSLATION_KEY.ESTAFFING,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.GOODJOB],
    value: TRANSLATION_KEY.GOODJOB,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.OTHER_NEW],
    value: TRANSLATION_KEY.OTHER_NEW.toLowerCase(),
  },
];

export const ONLINE_PAYMENT_PRICING_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.ONLINE_PAYMENT_PRICING_FREE],
    value: TRANSLATION_KEY.ONLINE_PAYMENT_PRICING_FREE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.ONLINE_PAYMENT_PRICING_PAID],
    value: TRANSLATION_KEY.ONLINE_PAYMENT_PRICING_PAID,
  },
];

export const CLIENT_TIME_CARD_TYPE_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.CLIENT_TIME_CARD_TYPE_HOTSTAFF],
    value: TRANSLATION_KEY.CLIENT_TIME_CARD_TYPE_HOTSTAFF,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.OTHER],
    value: TRANSLATION_KEY.OTHER.toLowerCase(),
  },
];

//DISPATCH TYPE
export const DISPATCH_TYPE_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.REGISTRATION_BASED],
    value: TRANSLATION_KEY.REGISTRATION_BASED,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.TEMP_TO_PERM],
    value: TRANSLATION_KEY.TEMP_TO_PERM,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.HIGHLY_SKILLED_PROFESSIONAL],
    value: TRANSLATION_KEY.HIGHLY_SKILLED_PROFESSIONAL,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.SHORT],
    value: TRANSLATION_KEY.SHORT,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.PERMANENT_EMPLOYEE],
    value: TRANSLATION_KEY.PERMANENT_EMPLOYEE,
  },
];

export const EMPLOYMENT_TRAINING_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.NEW_EMPLOYEE_TRAINING],
    value: TRANSLATION_KEY.NEW_EMPLOYEE_TRAINING,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.SAFETY_AND_HEALTH_EDUCATION],
    value: TRANSLATION_KEY.SAFETY_AND_HEALTH_EDUCATION,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.OJT],
    value: TRANSLATION_KEY.OJT,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.OTHER_NEW],
    value:
      TRANSLATION_KEY.OTHER_NEW.charAt(0).toUpperCase() +
      TRANSLATION_KEY.OTHER_NEW.slice(1),
  },
];

export const FACILITY_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FACILITY_UNIFORM],
    value: TRANSLATION_KEY.FACILITY_UNIFORM,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FACILITY_CAFETERIA],
    value: TRANSLATION_KEY.FACILITY_CAFETERIA,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FACILITY_BREAK_ROOM],
    value: TRANSLATION_KEY.FACILITY_BREAK_ROOM,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FACILITY_CHANGING_ROOM],
    value: TRANSLATION_KEY.FACILITY_CHANGING_ROOM,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FACILITY_LOCKER],
    value: TRANSLATION_KEY.FACILITY_LOCKER,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FACILITY_PARKING_LOT],
    value: TRANSLATION_KEY.FACILITY_PARKING_LOT,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FACILITY_HOSPITAL],
    value: TRANSLATION_KEY.FACILITY_HOSPITAL,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FACILITY_CLINIC],
    value: TRANSLATION_KEY.FACILITY_CLINIC,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FACILITY_BATHHOUSE],
    value: TRANSLATION_KEY.FACILITY_BATHHOUSE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FACILITY_SHOP],
    value: TRANSLATION_KEY.FACILITY_SHOP,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FACILITY_BARBER_SHOP],
    value: TRANSLATION_KEY.FACILITY_BARBER_SHOP,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FACILITY_NURSERY],
    value: TRANSLATION_KEY.FACILITY_NURSERY,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FACILITY_LIBRARY],
    value: TRANSLATION_KEY.FACILITY_LIBRARY,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FACILITY_AUDITORIUM],
    value: TRANSLATION_KEY.FACILITY_AUDITORIUM,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FACILITY_RECREATION_ROOM],
    value: TRANSLATION_KEY.FACILITY_RECREATION_ROOM,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FACILITY_SPORTS_GROUND],
    value: TRANSLATION_KEY.FACILITY_SPORTS_GROUND,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FACILITY_GYMNASIUM],
    value: TRANSLATION_KEY.FACILITY_GYMNASIUM,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FACILITY_RECUPERATION_FACILITY],
    value: TRANSLATION_KEY.FACILITY_RECUPERATION_FACILITY,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FACILITY_RECREATION_FACILITY],
    value: TRANSLATION_KEY.FACILITY_RECREATION_FACILITY,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.OTHER_NEW],
    value: TRANSLATION_KEY.OTHER_NEW,
  },
];

export const FACILITY_AVAILABILITY_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FACILITY_AVAILABLE],
    value: TRANSLATION_KEY.FACILITY_AVAILABLE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.NO_FACILITY_AVAILABLE],
    value: TRANSLATION_KEY.NO_FACILITY_AVAILABLE,
  },
];

export const AIR_CONDITIONING_OPTIONS = [
  {
    label:
      MAP_TRANSLATION[TRANSLATION_KEY.AIR_CONDITIONING_FULL_AIR_CONDITIONING],
    value: TRANSLATION_KEY.AIR_CONDITIONING_FULL_AIR_CONDITIONING,
  },
  {
    label:
      MAP_TRANSLATION[TRANSLATION_KEY.AIR_CONDITIONING_SPOT_AIR_CONDITIONING],
    value: TRANSLATION_KEY.AIR_CONDITIONING_SPOT_AIR_CONDITIONING,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.AIR_CONDITIONING_NONE],
    value: TRANSLATION_KEY.AIR_CONDITIONING_NONE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.AIR_CONDITIONING_OUTDOORS],
    value: TRANSLATION_KEY.AIR_CONDITIONING_OUTDOORS,
  },
];

// JOB LISTING EMPLOYMENT TYPE
export const JOB_LISTING_EMPLOYMENT_TYPE_OPTIONS = [
  {
    label:
      MAP_TRANSLATION[TRANSLATION_KEY.JOB_LISTING_EMPLOYMENT_TYPE_DISPATCH],
    value: TRANSLATION_KEY.JOB_LISTING_EMPLOYMENT_TYPE_DISPATCH,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.JOB_LISTING_EMPLOYMENT_TYPE_DISPATCH_PART_TIME
      ],
    value: TRANSLATION_KEY.JOB_LISTING_EMPLOYMENT_TYPE_DISPATCH_PART_TIME,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.JOB_LISTING_EMPLOYMENT_TYPE_TEMP_TO_PERM_PLACEMENT
      ],
    value: TRANSLATION_KEY.JOB_LISTING_EMPLOYMENT_TYPE_TEMP_TO_PERM_PLACEMENT,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY
          .JOB_LISTING_EMPLOYMENT_TYPE_EMPLOYMENT_PLACEMENT_FULL_TIME_EMPLOYEE
      ],
    value:
      TRANSLATION_KEY.JOB_LISTING_EMPLOYMENT_TYPE_EMPLOYMENT_PLACEMENT_FULL_TIME_EMPLOYEE,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY
          .JOB_LISTING_EMPLOYMENT_TYPE_EMPLOYMENT_PLACEMENT_FIXED_TERM_EMPLOYEE
      ],
    value:
      TRANSLATION_KEY.JOB_LISTING_EMPLOYMENT_TYPE_EMPLOYMENT_PLACEMENT_FIXED_TERM_EMPLOYEE,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY
          .JOB_LISTING_EMPLOYMENT_TYPE_FULL_TIME_EMPLOYEE_INCLUDING_PART_TIME
      ],
    value:
      TRANSLATION_KEY.JOB_LISTING_EMPLOYMENT_TYPE_FULL_TIME_EMPLOYEE_INCLUDING_PART_TIME,
  },
];

// JOB TYPE ID EMPLOYMENT TYPE
export const JOB_TYPE_ID_OPTIONS = [
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.JOB_TYPE_ID_EMPLOYMENT_SECURITY_OPERATIONS_STATISTICS
      ],
    value:
      TRANSLATION_KEY.JOB_TYPE_ID_EMPLOYMENT_SECURITY_OPERATIONS_STATISTICS,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.JOB_TYPE_ID_BASIC_WAGE_STRUCTURE_STATISTICS
      ],
    value: TRANSLATION_KEY.JOB_TYPE_ID_BASIC_WAGE_STRUCTURE_STATISTICS,
  },
];

export const WORKING_ON_HOLIDAY_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.WORKING_ON_HOLIDAY_MONTHLY_AVERAGE],
    value: TRANSLATION_KEY.WORKING_ON_HOLIDAY_MONTHLY_AVERAGE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.WORKING_ON_HOLIDAY_YEARLY_AVERAGE],
    value: TRANSLATION_KEY.WORKING_ON_HOLIDAY_YEARLY_AVERAGE,
  },
];

export const WORKING_OVERTIME_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.WORKING_ON_HOLIDAY_MONTHLY_AVERAGE],
    value: TRANSLATION_KEY.WORKING_ON_HOLIDAY_MONTHLY_AVERAGE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.WORKING_OVERTIME_DAILY_AVERAGE],
    value: TRANSLATION_KEY.WORKING_OVERTIME_DAILY_AVERAGE,
  },
];

export const WORKING_OVERTIME_WAGE_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.HOURS],
    value: TRANSLATION_KEY.HOURS,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.MINUTES],
    value: TRANSLATION_KEY.MINUTES,
  },
];

export const JOB_LISTING_DURATION_TYPE_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.JOB_LISTING_DURATION_TYPE_LONG_TERM],
    value: TRANSLATION_KEY.JOB_LISTING_DURATION_TYPE_LONG_TERM,
  },
  {
    label:
      MAP_TRANSLATION[TRANSLATION_KEY.JOB_LISTING_DURATION_TYPE_SHORT_TERM],
    value: TRANSLATION_KEY.JOB_LISTING_DURATION_TYPE_SHORT_TERM,
  },
];

export const JOB_LISTING_HOLIDAY_PREFERENCE_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.JOB_LISTING_HOLIDAY_WEEKENDS_OFF],
    value: TRANSLATION_KEY.JOB_LISTING_HOLIDAY_WEEKENDS_OFF,
  },
  {
    label:
      MAP_TRANSLATION[TRANSLATION_KEY.JOB_LISTING_HOLIDAY_FULL_WEEKENDS_OFF],
    value: TRANSLATION_KEY.JOB_LISTING_HOLIDAY_FULL_WEEKENDS_OFF,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.JOB_LISTING_HOLIDAY_WEEKENDS_AND_PUBLIC_HOLIDAYS_OFF
      ],
    value: TRANSLATION_KEY.JOB_LISTING_HOLIDAY_WEEKENDS_AND_PUBLIC_HOLIDAYS_OFF,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY
          .JOB_LISTING_HOLIDAY_FULL_WEEKENDS_AND_PUBLIC_HOLIDAYS_OFF
      ],
    value:
      TRANSLATION_KEY.JOB_LISTING_HOLIDAY_FULL_WEEKENDS_AND_PUBLIC_HOLIDAYS_OFF,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.JOB_LISTING_HOLIDAY_TWO_DAYS_OFF_PER_WEEK_SHIFT_BASED
      ],
    value:
      TRANSLATION_KEY.JOB_LISTING_HOLIDAY_TWO_DAYS_OFF_PER_WEEK_SHIFT_BASED,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY
          .JOB_LISTING_HOLIDAY_FULL_TWO_DAYS_OFF_PER_WEEK_SHIFT_BASED
      ],
    value:
      TRANSLATION_KEY.JOB_LISTING_HOLIDAY_FULL_TWO_DAYS_OFF_PER_WEEK_SHIFT_BASED,
  },
  {
    label:
      MAP_TRANSLATION[TRANSLATION_KEY.JOB_LISTING_HOLIDAY_DAYS_ON_DAYS_OFF],
    value: TRANSLATION_KEY.JOB_LISTING_HOLIDAY_DAYS_ON_DAYS_OFF,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.JOB_LISTING_HOLIDAY_WEEKDAYS_OFF],
    value: TRANSLATION_KEY.JOB_LISTING_HOLIDAY_WEEKDAYS_OFF,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.OTHERS],
    value: TRANSLATION_KEY.OTHERS,
  },
];

export const JOB_LISTING_ALLOWANCE_OPTIONS = [
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.JOB_LISTING_ALLOWANCE_PERFECT_ATTENDANCE_ALLOWANCE
      ],
    value: TRANSLATION_KEY.JOB_LISTING_ALLOWANCE_PERFECT_ATTENDANCE_ALLOWANCE,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.JOB_LISTING_ALLOWANCE_DILIGENCE_ALLOWANCE
      ],
    value: TRANSLATION_KEY.JOB_LISTING_ALLOWANCE_DILIGENCE_ALLOWANCE,
  },
  {
    label:
      MAP_TRANSLATION[TRANSLATION_KEY.JOB_LISTING_ALLOWANCE_MEAL_ALLOWANCE],
    value: TRANSLATION_KEY.JOB_LISTING_ALLOWANCE_MEAL_ALLOWANCE,
  },
  {
    label:
      MAP_TRANSLATION[TRANSLATION_KEY.JOB_LISTING_ALLOWANCE_HOUSING_ALLOWANCE],
    value: TRANSLATION_KEY.JOB_LISTING_ALLOWANCE_HOUSING_ALLOWANCE,
  },
  {
    label:
      MAP_TRANSLATION[TRANSLATION_KEY.JOB_LISTING_ALLOWANCE_FAMILY_ALLOWANCE],
    value: TRANSLATION_KEY.JOB_LISTING_ALLOWANCE_FAMILY_ALLOWANCE,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.JOB_LISTING_ALLOWANCE_YEAR_END_AND_NEW_YEAR_ALLOWANCE
      ],
    value:
      TRANSLATION_KEY.JOB_LISTING_ALLOWANCE_YEAR_END_AND_NEW_YEAR_ALLOWANCE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.OTHERS],
    value: TRANSLATION_KEY.OTHERS,
  },
];

export const JOB_LISTING_FIELD_STUDY_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FIELD_STUDY_NO_PREFERENCE],
    value: TRANSLATION_KEY.FIELD_STUDY_NO_PREFERENCE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FIELD_STUDY_INDUSTRIAL],
    value: TRANSLATION_KEY.FIELD_STUDY_INDUSTRIAL,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FIELD_STUDY_COMMERCE],
    value: TRANSLATION_KEY.FIELD_STUDY_COMMERCE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.OTHERS],
    value: TRANSLATION_KEY.OTHERS.toLowerCase(),
  },
];

export const GENDER_EXTENDED_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.GENDER_MALE],
    value: TRANSLATION_KEY.GENDER_MALE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.GENDER_FEMALE],
    value: TRANSLATION_KEY.GENDER_FEMALE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.GENDER_MALE_FEMALE],
    value: TRANSLATION_KEY.GENDER_MALE_FEMALE,
  },
];

export const JOB_LISTING_CERTIFICATIONS_OPTIONS = [
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_DRIVERS_LICENSE
      ],
    value: TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_DRIVERS_LICENSE,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_LARGE_VEHICLE_DRIVERS_LICENSE
      ],
    value:
      TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_LARGE_VEHICLE_DRIVERS_LICENSE,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_FORKLIFT_CERTIFICATION
      ],
    value: TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_FORKLIFT_CERTIFICATION,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_SLINGING_CERTIFICATION
      ],
    value: TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_SLINGING_CERTIFICATION,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_CRANE_CERTIFICATION
      ],
    value: TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_CRANE_CERTIFICATION,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_BOOKKEEPING_LEVEL_3
      ],
    value: TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_BOOKKEEPING_LEVEL_3,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_BOOKKEEPING_LEVEL_2
      ],
    value: TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_BOOKKEEPING_LEVEL_2,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_NURSERY_TEACHER_LICENSE
      ],
    value: TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_NURSERY_TEACHER_LICENSE,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_KINDERGARTEN_TEACHER_LICENSE
      ],
    value:
      TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_KINDERGARTEN_TEACHER_LICENSE,
  },
  {
    label:
      MAP_TRANSLATION[TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_COOK_LICENSE],
    value: TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_COOK_LICENSE,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_NUTRITIONIST_LICENSE
      ],
    value: TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_NUTRITIONIST_LICENSE,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_HELPER_LEVEL_2
      ],
    value: TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_HELPER_LEVEL_2,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY
          .JOB_LISTING_CERTIFICATIONS_CERTIFIED_CARE_WORKER_BEGINNER_TRAINING
      ],
    value:
      TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_CERTIFIED_CARE_WORKER_BEGINNER_TRAINING,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.OTHER_NEW],
    value: TRANSLATION_KEY.OTHER_NEW,
  },
];

export const JOB_LISTING_EXPERIENCE_OPTIONS = [
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.JOB_LISTING_EXPERIENCE_MANUFACTURING_EXPERIENCE
      ],
    value: TRANSLATION_KEY.JOB_LISTING_EXPERIENCE_MANUFACTURING_EXPERIENCE,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.JOB_LISTING_EXPERIENCE_INSPECTION_EXPERIENCE
      ],
    value: TRANSLATION_KEY.JOB_LISTING_EXPERIENCE_INSPECTION_EXPERIENCE,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.JOB_LISTING_EXPERIENCE_FORKLIFT_OPERATION_EXPERIENCE
      ],
    value: TRANSLATION_KEY.JOB_LISTING_EXPERIENCE_FORKLIFT_OPERATION_EXPERIENCE,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.JOB_LISTING_EXPERIENCE_MACHINE_OPERATION_EXPERIENCE
      ],
    value: TRANSLATION_KEY.JOB_LISTING_EXPERIENCE_MACHINE_OPERATION_EXPERIENCE,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.JOB_LISTING_EXPERIENCE_FOOD_MANUFACTURING_EXPERIENCE
      ],
    value: TRANSLATION_KEY.JOB_LISTING_EXPERIENCE_FOOD_MANUFACTURING_EXPERIENCE,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.JOB_LISTING_EXPERIENCE_CLERICAL_WORK_EXPERIENCE
      ],
    value: TRANSLATION_KEY.JOB_LISTING_EXPERIENCE_CLERICAL_WORK_EXPERIENCE,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.JOB_LISTING_EXPERIENCE_TELEPHONE_HANDLING_EXPERIENCE
      ],
    value: TRANSLATION_KEY.JOB_LISTING_EXPERIENCE_TELEPHONE_HANDLING_EXPERIENCE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.OTHER_NEW],
    value: TRANSLATION_KEY.OTHER_NEW,
  },
];

export const JOB_LISTING_PRODUCTION_WHITE_COLLAR_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.PRODUCTION],
    value: TRANSLATION_KEY.PRODUCTION,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.WHITE_COLLAR],
    value: TRANSLATION_KEY.WHITE_COLLAR,
  },
];

export const TIME_FREQUENCY_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.DAILY],
    value: TRANSLATION_KEY.DAILY,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.HOURLY],
    value: TRANSLATION_KEY.HOURLY,
  },
];

export const UNIFORM_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.UNIFORM_PROVIDED],
    value: TRANSLATION_KEY.UNIFORM_PROVIDED,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.PREPARE_OWN],
    value: TRANSLATION_KEY.PREPARE_OWN,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.NONE],
    value: TRANSLATION_KEY.NONE,
  },
];

export const MID_SHIFT_BREAK_METHOD_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FACILITY_CAFETERIA],
    value: TRANSLATION_KEY.FACILITY_CAFETERIA,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FACILITY_BREAK_ROOM],
    value: TRANSLATION_KEY.FACILITY_BREAK_ROOM,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.GOING_PUT_PERMITTED],
    value: TRANSLATION_KEY.GOING_PUT_PERMITTED,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.STAYING_IN_CAR_PERMITTED],
    value: TRANSLATION_KEY.STAYING_IN_CAR_PERMITTED,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.TEMPORARY_RETURN_HOME_PERMITTED],
    value: TRANSLATION_KEY.TEMPORARY_RETURN_HOME_PERMITTED,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.OTHER_NEW],
    value: TRANSLATION_KEY.OTHER_NEW,
  },
];

export const GROOMING_REGULATION_HAIR_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.HAIR_FREE],
    value: TRANSLATION_KEY.HAIR_FREE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.BLACK_TO_DARK_BROWN],
    value: TRANSLATION_KEY.BLACK_TO_DARK_BROWN,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.BLACK],
    value: TRANSLATION_KEY.BLACK,
  },
];

export const GROOMING_REGULATION_NAILS_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FREE],
    value: TRANSLATION_KEY.FREE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.SIMPLE_NAILS_OK],
    value: TRANSLATION_KEY.SIMPLE_NAILS_OK,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.NOT_ALLOWED],
    value: TRANSLATION_KEY.NOT_ALLOWED,
  },
];

export const GROOMING_REGULATION_TATTOO_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FREE],
    value: TRANSLATION_KEY.FREE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.OK_IF_HIDDEN],
    value: TRANSLATION_KEY.OK_IF_HIDDEN,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.NO_TATTOOS],
    value: TRANSLATION_KEY.NO_TATTOOS,
  },
];

export const GROOMING_REGULATION_BEARD_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.FREE],
    value: TRANSLATION_KEY.FREE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.OK_IF_KEPT_CLEAN],
    value: TRANSLATION_KEY.OK_IF_KEPT_CLEAN,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.NO_BREADS],
    value: TRANSLATION_KEY.NO_BREADS,
  },
];

export const EMPLOYMENT_QUALIFICATION_OPTIONS = [
  {
    label:
      MAP_TRANSLATION[TRANSLATION_KEY.EMPLOYMENT_QUALIFICATION_DRIVERS_LICENSE],
    value: TRANSLATION_KEY.EMPLOYMENT_QUALIFICATION_DRIVERS_LICENSE,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.EMPLOYMENT_QUALIFICATION_CLASS_2_HEALTH_SUPERVISOR
      ],
    value: TRANSLATION_KEY.EMPLOYMENT_QUALIFICATION_CLASS_2_HEALTH_SUPERVISOR,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.EMPLOYMENT_QUALIFICATION_DISPATCHING_AGENCY_MANAGER
      ],
    value: TRANSLATION_KEY.EMPLOYMENT_QUALIFICATION_DISPATCHING_AGENCY_MANAGER,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY
          .EMPLOYMENT_QUALIFICATION_FEE_CHARGING_EMPLOYMENT_PLACEMENT_MANAGER
      ],
    value:
      TRANSLATION_KEY.EMPLOYMENT_QUALIFICATION_FEE_CHARGING_EMPLOYMENT_PLACEMENT_MANAGER,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.EMPLOYMENT_QUALIFICATION_CAREER_CONSULTANT
      ],
    value: TRANSLATION_KEY.EMPLOYMENT_QUALIFICATION_CAREER_CONSULTANT,
  },
];

export const AFFILIATED_BRANCH_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.AFFILIATED_BRANCH_BRANCH],
    value: TRANSLATION_KEY.AFFILIATED_BRANCH_BRANCH,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.AFFILIATED_BRANCH_MAIN],
    value: TRANSLATION_KEY.AFFILIATED_BRANCH_MAIN,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.AFFILIATED_BRANCH_HEADQUARTER],
    value: TRANSLATION_KEY.AFFILIATED_BRANCH_HEADQUARTER,
  },
];

export const EMPLOYMENT_BRANCH_TYPE_BRANCH_OPTIONS = [
  {
    label:
      MAP_TRANSLATION[TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_SALES_DEPARTMENT],
    value: TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_SALES_DEPARTMENT,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_ADMINISTRATION_DEPARTMENT
      ],
    value: TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_ADMINISTRATION_DEPARTMENT,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_CLERICAL],
    value: TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_CLERICAL,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_COORDINATOR],
    value: TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_COORDINATOR,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_ATTENDANT],
    value: TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_ATTENDANT,
  },
];

export const EMPLOYMENT_BRANCH_TYPE_MAIN_OPTIONS = [
  {
    label:
      MAP_TRANSLATION[TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_IT_DEPARTMENT],
    value: TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_IT_DEPARTMENT,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_PUBLIC_RELATIONS_DEPARTMENT
      ],
    value: TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_PUBLIC_RELATIONS_DEPARTMENT,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_MARKETING_DEPARTMENT
      ],
    value: TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_MARKETING_DEPARTMENT,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_CONTROL_DEPARTMENT
      ],
    value: TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_CONTROL_DEPARTMENT,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_GENERAL_AFFAIRS_SECTION
      ],
    value: TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_GENERAL_AFFAIRS_SECTION,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_ADMINISTRATION_SECTION
      ],
    value: TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_ADMINISTRATION_SECTION,
  },
  {
    label:
      MAP_TRANSLATION[TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_EDUCATION_SECTION],
    value: TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_EDUCATION_SECTION,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_HUMAN_RESOURCES_SECTION
      ],
    value: TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_HUMAN_RESOURCES_SECTION,
  },
];

export const EMPLOYMENT_BRANCH_TYPE_HEADQUARTER_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_SECTION_ONE],
    value: TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_SECTION_ONE,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_SECTION_TWO],
    value: TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_SECTION_TWO,
  },
];

export const CLIENT_COMPANY_PIC_OPETIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.ORGANIZATION_CHIEF],
    value: TRANSLATION_KEY.ORGANIZATION_CHIEF,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.COMMANDER],
    value: TRANSLATION_KEY.COMMANDER,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.CORPORATION_PIC],
    value: TRANSLATION_KEY.CORPORATION_PIC,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.CORPORATION_COMPLAINT_OFFICER],
    value: TRANSLATION_KEY.CORPORATION_COMPLAINT_OFFICER,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.HOTSTAFF_PIC],
    value: TRANSLATION_KEY.HOTSTAFF_PIC,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.HOTSTAFF_COMPLAINT_OFFICER],
    value: TRANSLATION_KEY.HOTSTAFF_COMPLAINT_OFFICER,
  },
];

// DESIRED NATIONALITY
export const DESIRED_NATIONALITY_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.DESIRED_NATIONALITY_JAPANSESE_ONLY],
    value: TRANSLATION_KEY.DESIRED_NATIONALITY_JAPANSESE_ONLY,
  },
  {
    label:
      MAP_TRANSLATION[TRANSLATION_KEY.DESIRED_NATIONALITY_FOREIGN_WORKERS_ONLY],
    value: TRANSLATION_KEY.DESIRED_NATIONALITY_FOREIGN_WORKERS_ONLY,
  },
  {
    label:
      MAP_TRANSLATION[
        TRANSLATION_KEY.DESIRED_NATIONALITY_JAPANSESE_AND_FOREIGN_WORKERS
      ],
    value: TRANSLATION_KEY.DESIRED_NATIONALITY_JAPANSESE_AND_FOREIGN_WORKERS,
  },
];

export const NEAREST_STATION_MODE_OPTIONS = [
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.NEAREST_STATION_MODE_CAR],
    value: TRANSLATION_KEY.NEAREST_STATION_MODE_CAR,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.NEAREST_STATION_MODE_WALKING],
    value: TRANSLATION_KEY.NEAREST_STATION_MODE_WALKING,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.NEAREST_STATION_MODE_BUS],
    value: TRANSLATION_KEY.NEAREST_STATION_MODE_BUS,
  },
  {
    label: MAP_TRANSLATION[TRANSLATION_KEY.NEAREST_STATION_MODE_TRAIN],
    value: TRANSLATION_KEY.NEAREST_STATION_MODE_TRAIN,
  },
];

export const BRANCH_TAG_OPTIONS: TInputTag[] = [
  ...EMPLOYMENT_BRANCH_TYPE_BRANCH_OPTIONS,
  ...EMPLOYMENT_BRANCH_TYPE_MAIN_OPTIONS,
  ...EMPLOYMENT_BRANCH_TYPE_HEADQUARTER_OPTIONS,
].map((opt) => ({
  id: opt.value,
  name: opt.label,
}));

export const MISSING_TRANSLATION_MESSAGE = "(missing japanese translation)";
